import data from '../cities.json';

const cityWhatIfsData = {
    "current": Object.keys(data).map(citySlug => {
        const cityData = data[citySlug];
        return {
            "City": cityData.city,
            "Country": cityData.country,
            "Slug": citySlug,
            "FREI": {
                "value": cityData.future_readiness_score,
                "rank": cityData.future_readiness_rank,
            },
            "PeopleCentricity": {
                "value": cityData.people_centricity_score,
                "rank": cityData.people_centricity_rank,
            },
            "Openness": {
                "value": cityData.openness_score,
                "rank": cityData.openness_rank,
            },
            "Sustainability": {
                "value": cityData.sustainability_score,
                "rank": cityData.sustainability_rank,
            },
            "InstitutionsGovernance": {
                "value": cityData.institutions_governance_score,
                "rank": cityData.institutions_governance_rank,
            },
            "TransportInfrastructure": {
                "value": cityData.transport_infrastructure_score,
                "rank": cityData.transport_infrastructure_rank,
            },
            "Innovation": {
                "value": cityData.innovation_score,
                "rank": cityData.innovation_rank,
            },
            "Vibrancy": {
                "value": cityData.vibrancy_score,
                "rank": cityData.vibrancy_rank,
            },
            "EIntelligence": {
                "value": cityData.e_intelligence_score,
                "rank": cityData.e_intelligence_rank,
            }
        };
    })
};

export default cityWhatIfsData;
